var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { locationTypeEntityName, missionLocationEntityName, } from '../../../../backend/config/classifiers';
import { StorageClient } from '@juvare/platform-sdk-js/StorageClient';
import { ClassifierAdminPage, ClassifierValue, SlideoutFields, } from '@juvare/platform-sdk-react/ui/features/classifiers';
import { StateClassifierValue } from '@juvare/platform-sdk-react/ui/features/default-classifiers';
import { capitalize } from '@mui/material';
import React from 'react';
import { getClassifierIdByName, getClassifierNames, getPostalCodeByName, getStateNameByPostalCode, validateZipCode } from './utils';
function getEntityTitle(row) {
    return row.columns.name;
}
const EntityDetailsComponent = (props) => {
    const { status, type, address, address2, city, state, county, zip } = props.response.data;
    return (React.createElement(SlideoutFields, { fields: [
            { label: 'Status', value: capitalize(status) },
            { label: 'Location type', value: React.createElement(ClassifierValue, { entity: locationTypeEntityName, id: type }) },
            { label: 'Address Line 1', value: capitalize(address) },
            { label: 'Address Line 2', value: capitalize(address2 !== null && address2 !== void 0 ? address2 : '') },
            { label: 'City', value: capitalize(city) },
            { label: 'State', value: React.createElement(StateClassifierValue, { state: state }) },
            { label: 'County', value: capitalize(county) },
            { label: 'ZIP', value: zip },
        ] }));
};
const formConfig = {
    key: '!form',
    type: 'form',
    children: [
        {
            type: 'form.text',
            key: 'name',
            label: 'Name',
            validate: {
                required: true,
            },
        },
        {
            type: 'form.select',
            key: 'status',
            label: 'Status',
            validate: {
                required: true,
            },
            values: [
                {
                    value: 'active',
                    label: 'Active',
                },
                {
                    value: 'deprecated',
                    label: 'Deprecated',
                },
                {
                    value: 'retired',
                    label: 'Retired',
                },
            ],
        },
        {
            type: 'form.select',
            key: 'type',
            label: 'Location Type',
            validate: {
                required: true,
            },
            valueProvider: {
                type: 'classifier.locationType',
            },
        },
        {
            type: 'form.text',
            key: 'address',
            label: 'Address Line 1',
            validate: {
                required: true,
            },
        },
        {
            type: 'form.text',
            key: 'address2',
            label: 'Address Line 2',
        },
        {
            type: 'form.text',
            key: 'city',
            label: 'City',
            validate: {
                required: true,
            },
        },
        {
            type: 'form.select',
            key: 'state',
            label: 'State/Region',
            validate: {
                required: true,
            },
            valueProvider: { type: 'availableMissionLocationStates' },
        },
        {
            type: 'form.select',
            key: 'county',
            label: 'County',
            validate: {
                required: true,
            },
            disabled: { whenNoValues: true },
            valueProvider: { type: 'classifier.county', paramsFrom: '^state' },
        },
        {
            type: 'form.text',
            key: 'zip',
            label: 'ZIP',
            validate: {
                required: true,
                regex: '\\d{5}',
            },
        },
    ],
};
const csvFileHeader = ['ID', 'Name', 'Status', 'Location type', 'Address', 'Address 2', 'City', 'State', 'County', 'ZIP'];
function mapCsvRowToData(row) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const id = ((_a = row.data[0]) !== null && _a !== void 0 ? _a : '').trim();
        const name = ((_b = row.data[1]) !== null && _b !== void 0 ? _b : '').trim();
        const status = ((_c = row.data[2]) !== null && _c !== void 0 ? _c : '').trim().toLowerCase();
        const type = ((_d = row.data[3]) !== null && _d !== void 0 ? _d : '').trim();
        const address = ((_e = row.data[4]) !== null && _e !== void 0 ? _e : '').trim().toLowerCase();
        const address2 = ((_f = row.data[5]) !== null && _f !== void 0 ? _f : '').trim().toLowerCase();
        const city = ((_g = row.data[6]) !== null && _g !== void 0 ? _g : '').trim();
        const state = ((_h = row.data[7]) !== null && _h !== void 0 ? _h : '').trim();
        const county = ((_j = row.data[8]) !== null && _j !== void 0 ? _j : '').trim();
        const zip = ((_k = row.data[9]) !== null && _k !== void 0 ? _k : '').trim();
        if (name.length === 0) {
            row.errors.push('Name is required');
        }
        if (status.length === 0) {
            row.errors.push('Status is required');
        }
        if (type.length === 0) {
            row.errors.push('Location type is required');
        }
        if (city.length === 0) {
            row.errors.push('City is required');
        }
        if (address.length === 0) {
            row.errors.push('Address is required');
        }
        if (zip.length === 0) {
            row.errors.push('ZIP is required');
        }
        if (state.length === 0) {
            row.errors.push('State is required');
        }
        if (county.length === 0) {
            row.errors.push('County is required');
        }
        switch (status) {
            case 'active':
            case 'deprecated':
            case 'retired':
                break;
            default:
                row.errors.push('Invalid status, expected one of: active, deprecated, retired');
        }
        const typeId = yield getClassifierIdByName(locationTypeEntityName, type, row.errors, 'Type not found: ' + type);
        const statePostalCode = yield getPostalCodeByName(state, row.errors, 'State not found: ' + state);
        if (county) {
            yield getPostalCodeByName(county, row.errors, 'County not found: ' + county, [
                { column: 'parentPostalCode', op: '=', value: statePostalCode },
                { column: 'type', op: '=', value: 'county' },
                { column: 'status', op: '=', value: 'active' },
            ]);
        }
        const settingStorage = new StorageClient('setting');
        const availableMissionLocationStatesSetting = yield settingStorage.list({
            filter: [
                {
                    column: 'name',
                    op: '=',
                    value: 'availableMissionLocationStates',
                },
            ],
        });
        const [availableMissionLocationStates] = availableMissionLocationStatesSetting.rows;
        const { availableStates } = JSON.parse(availableMissionLocationStates.columns.value);
        if (!availableStates.includes(statePostalCode)) {
            row.errors.push(`State is not available: ${state}`);
        }
        if (!validateZipCode(zip)) {
            row.errors.push(`Invalid ZIP Code: ${zip}`);
        }
        if (row.errors.length === 0) {
            row.object = {
                id: id,
                data: {
                    name: name,
                    status: status,
                    type: typeId !== null && typeId !== void 0 ? typeId : '',
                    address: address,
                    address2: address2,
                    city: city,
                    state: statePostalCode !== null && statePostalCode !== void 0 ? statePostalCode : '',
                    county: county !== null && county !== void 0 ? county : '',
                    zip: zip,
                },
            };
        }
        return Promise.resolve(row);
    });
}
function mapDataToCsvRow(response) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        return [
            response.id,
            response.data.name,
            response.data.status,
            yield getClassifierNames(locationTypeEntityName, response.data.type),
            response.data.address,
            (_a = response.data.address2) !== null && _a !== void 0 ? _a : '',
            response.data.city,
            yield getStateNameByPostalCode(response.data.state),
            response.data.county,
            response.data.zip,
        ];
    });
}
export const MissionLocationAdminPage = () => {
    return (React.createElement(ClassifierAdminPage, { entity: missionLocationEntityName, title: 'Mission Location', fullTextSearchField: 'search', getEntityTitle: getEntityTitle, entityDetailsComponent: EntityDetailsComponent, formConfig: formConfig, csvFileHeader: csvFileHeader, mapCsvRowToData: mapCsvRowToData, mapDataToCsvRow: mapDataToCsvRow }));
};
